import {isNotNil} from 'ramda';
import {isString} from 'ramda-adjunct';

export const formatExternalFiltersDate = (date: Date | string | null | undefined) => {
  if (isNotNil(date)) {
    if (isString(date)) {
      return date;
    }
    return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(
      date.getDate()
    ).padStart(2, '0')}`;
  }
  return null;
};
